import React from "react";
import { Route } from "react-router-dom";
import { Cnt_MainSearch, Cnt_Home } from "containers";

export default (caseNo: number) => {
  return [
    <Route key="home" path="/" element={<Cnt_Home />} />,
    <Route key="search" path="/search" element={<Cnt_MainSearch />} />,
  ];
};
